import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.keys.js";
import AuthorImg from "./AuthorImg";
import { mapState } from "vuex";
export default {
  name: "MyInvitationItem",
  components: {
    AuthorImg: AuthorImg
  },
  data: function data() {
    return {};
  },
  props: {
    item: {
      type: Object,
      default: {
        addTime: "2023-01-16T16:25:41Z",
        addUserId: "31223",
        headImg: "/d/file/headimg/2022/05/M8Uo608CGDNsAzPL0cbuSMkmW8Iz3sb7.png",
        identificationDesc: "我不是一个车主哈哈哈哈哈2223333",
        integral: "368",
        isVip: "1",
        nickName: "刘刘",
        status: "1",
        summary: "很懒",
        targetId: "3",
        userType: "2",
        vipName: "我不是一个车主哈哈哈哈哈2223333"
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState(["uid", "token", "time", "isTest", "totalIngral"])), {}, {
    isMe: function isMe() {
      return this.item.addUserId === this.uid;
    },
    notEmpty: function notEmpty() {
      return Object.keys(this.item).length;
    },
    statusText: function statusText() {
      return ["已取消", "未开始", "进行中"][this.item.status - 0 + 1];
    }
  }),
  mounted: function mounted() {}
};